import { $devLog } from '@/utils/devLog';

export async function clearServerAnalyticsEvents() {
  try {
    const response = await fetch('/api/analytics/clear-events');
    if (!response.ok) {
      $devLog('Failed to clear server events, non-200 response status returned');
    }
  } 
  catch (ex) {
    $devLog('Failed to clear server events');
  }
}